import { FC, useState } from 'react'

import { useNavigate } from 'react-router-dom'

import {
  Button,
  SequenceMenu,
  SetIsOpen,
  IconPlus
} from '@sequencehq/core-components'

import { ProtectedButton, ProtectedComponent } from 'lib/rbac'
import { NEW_PRICE_PREFIX } from 'common/drawers/PricingEditor/domain/pricingEditor.constants'
import { useProduct } from 'modules/Products/hooks/useProduct'
import { EditProductForm } from 'modules/Products/drawers/EditProduct/EditProductForm'
import { ArchiveProductMenuItem } from 'Products/menuItems'

export const HeaderButtons: FC = () => {
  const { product } = useProduct()
  const navigate = useNavigate()
  const [isEditing, setIsEditing] = useState(false)

  if (!product) return null

  return (
    <>
      {isEditing && (
        <EditProductForm
          productId={product.id}
          onClose={() => setIsEditing(false)}
        />
      )}
      <ProtectedButton permission="org.product:update">
        <Button
          variant="secondary"
          aria-label="Edit product"
          data-testid="product.editProduct"
          onClick={() => setIsEditing(true)}
        >
          Edit product
        </Button>
      </ProtectedButton>

      <ProtectedButton permission="org.product:create">
        <Button
          variant="primary"
          aria-label="Create new list price"
          onClick={() =>
            navigate(
              `/products/${
                product.id
              }/list-price/${NEW_PRICE_PREFIX}${crypto.randomUUID()}`
            )
          }
          leadingIcon={<IconPlus color="inherit" />}
          data-testid="product.newListPrice"
        >
          New list price
        </Button>
      </ProtectedButton>

      <ProtectedComponent permission="org.product:archive">
        <SequenceMenu
          data-testid={`product.${product.id}.menu`}
          variant="ghost"
          alignment="bottom-right"
          items={[
            ({ setIsOpen }: { setIsOpen?: SetIsOpen }) => (
              <ArchiveProductMenuItem
                key="archive-product"
                productId={product.id}
                productName={product.name}
                onClose={() => {
                  setIsOpen?.(false)
                }}
                onSuccess={() => {
                  setIsOpen?.(false)
                  navigate(`/products`)
                }}
              />
            )
          ]}
        />
      </ProtectedComponent>
    </>
  )
}
